import { ref, onMounted, onUnmounted } from 'vue'

export function useScrollShadow(scrollEl) {
    const showLeft = ref(false)
    const showRight = ref(false)

    function update() {
        if (!scrollEl.value) {
            return
        }

        const { scrollLeft, scrollWidth, clientWidth } = scrollEl.value

        showLeft.value = scrollLeft > 0
        showRight.value = scrollLeft + clientWidth < scrollWidth - 1
    }

    onMounted(() => {
        if (!scrollEl.value) {
            return
        }

        update()

        scrollEl.value.addEventListener('scroll', update, { passive: true })

        const resizeObserver = new ResizeObserver(update)
        resizeObserver.observe(scrollEl.value)

        if (scrollEl.value.firstElementChild) {
            resizeObserver.observe(scrollEl.value.firstElementChild)
        }

        onUnmounted(() => {
            if (!scrollEl.value) {
                return
            }

            scrollEl.value.removeEventListener('scroll', update)
            resizeObserver.disconnect()
        })
    })

    return { showLeft, showRight }
}
